export async function catalogRequest<T>(path: string, method = "GET", body?: unknown): Promise<T> {
  let result: Response;
  try { result = await fetch(`/api/workspace${path}`, {
    method, credentials: "same-origin", cache: "no-store", signal: AbortSignal.timeout(20000),
    headers: method === "GET" ? {} : {"Content-Type": "application/json", "X-Egel-Workspace": "1"},
    body: body === undefined ? undefined : JSON.stringify(body)
  }); } catch { throw new Error("Нет связи с витриной. Проверьте подключение и повторите попытку"); }
  const data = await result.json().catch(() => null);
  if (!result.ok || !data) throw new Error(data?.error ?? "Витрина временно недоступна");
  return data as T;
}
